import store from "@/store/index";
import CRUD from "@/firebase/crud";

const user = {
  namespaced: true,
  state: {
    active: {
      userID: "",
      userLevel: "",
      sponsorID: "",
      emailVerified: "",
      fullName: ""
    }
  },
  mutations: {
    setCurrentUser(state, data) {
      state.active = data;
    },
    setLoggedIn(state, data) {
      state.active = data;
    },
    setUserProfile(state, [name, data]) {
      state.active[name]= data;
    }
  },
  actions: {
    //unused 18.07.2019
    fetchUserProfile({ commit, state }) {
      let userDocument = Promise.resolve(
        CRUD.GetDocumentByID(
          "users",
          store.state.user.active.uid
        )
      );
      userDocument.then(response => {
        //console.log("userDocument = " + JSON.stringify(response.data));
        commit('setUserProfile', ['userID', response.data.userID]);
        commit('setUserProfile', ['userLevel', response.data.userLevel]);
        commit('setUserProfile', ['emailVerified', response.data.emailVerified]);
        commit('setUserProfile', ['emailVerified', response.data.fullName]);
        commit('setUserProfile', ['emailVerified', response.data.sponsorID]);
      });
    }
  }
};

export default user;
